import { useEffect, useState } from "react";
import { useTemplate } from "./useTemplate";

export const useGetTemplateList = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState(null);
  const { getList } = useTemplate();

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await getList();
      if (res.status >= 400) {
        throw new Error(`${res.status}`);
      }
      setData(res.data);
    } catch (error) {
      setError("Ошибка загрузки списка шаблонов");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, isLoading, error };
};
